import React, { useEffect, useState } from 'react';
import { SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import SafeSwiper from '../Common/SafeSwiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

const TestimonialItem = ({ image, name, role, quote }) => {
  return (
    <div className="testimonial-item">
      <img src={`/assets/img/testimonials/${image}`} className="testimonial-img" alt="" />
      <h3>{name}</h3>
      <h4>{role}</h4>
      <div className="stars">
        <i className="bi bi-star-fill"></i>
        <i className="bi bi-star-fill"></i>
        <i className="bi bi-star-fill"></i>
        <i className="bi bi-star-fill"></i>
        <i className="bi bi-star-fill"></i>
      </div>
      <p>
        <i className="bi bi-quote quote-icon-left"></i>
        <span>{quote}</span>
        <i className="bi bi-quote quote-icon-right"></i>
      </p>
    </div>
  );
};

const Testimonials = () => {
  const [swiperKey, setSwiperKey] = useState(Date.now());
  
  useEffect(() => {
    // Force re-render of Swiper if the component is visible
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setSwiperKey(Date.now());
      }
    });
    
    const section = document.getElementById('testimonials');
    if (section) {
      observer.observe(section);
    }
    
    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);
  
  const testimonials = [
    {
      image: 'testimonials-1.jpg',
      name: 'Ravi Mehta',
      role: 'IT Manager',
      quote: "Awesome support from technical team! Digisoft's cloud computing solutions have significantly improved our operational efficiency. Our team collaborates seamlessly from anywhere, and our data security is top-notch. Digisoft is truly our trusted technology partner."
    },
    {
      image: 'testimonials-2.jpg',
      name: 'Neha Sharma',
      role: 'Investment Advisor',
      quote: "Awesome design quality with great support. Digisoft's SharePro services have revolutionized how we manage our investments. Their team's deep understanding of the financial domain has added immense value to our firm. We couldn't be more satisfied."
    },
    {
      image: 'testimonials-3.jpg',
      name: 'Suresh Iyer',
      role: 'Finance Head',
      quote: "Contacted support after midnight and still received excellent help! Our financial operations have been transformed thanks to Digisoft's TallyPrime solutions. We've achieved cost savings and better insights. Their expertise and dedication are commendable."
    },
    {
      image: 'testimonials-4.jpg',
      name: 'Priya Desai',
      role: 'Entrepreneur',
      quote: "Digisoft's services have brought great value to our growing business. The back-office automation tools helped us streamline workflows and focus more on customer experience. Truly reliable and efficient support."
    },
    {
      image: 'testimonials-5.jpg',
      name: 'Amit Verma',
      role: 'Chartered Accountant',
      quote: "Being in compliance-heavy roles, we needed a dependable tech partner. Digisoft's ERP solutions have helped us stay audit-ready and efficient. Their team is knowledgeable, responsive, and genuinely helpful."
    }
  ];

  return (
    <section id="testimonials" className="testimonials section dark-background">
      <img src="/assets/img/testimonials-bg.jpg" className="testimonials-bg" alt="" />

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <SafeSwiper
          key={swiperKey}
          modules={[Pagination, Autoplay]}
          speed={600}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false
          }}
          slidesPerView={1}
          spaceBetween={30}
          breakpoints={{
            768: {
              slidesPerView: 2
            },
            1024: {
              slidesPerView: 3
            }
          }}
          pagination={{
            el: '.swiper-pagination',
            clickable: true
          }}
          className="mySwiper"
          grabCursor={true}
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <TestimonialItem 
                image={testimonial.image} 
                name={testimonial.name} 
                role={testimonial.role} 
                quote={testimonial.quote} 
              />
            </SwiperSlide>
          ))}
          <div className="swiper-pagination"></div>
        </SafeSwiper>
      </div>
    </section>
  );
};

export default Testimonials; 